const CLASS_NAME = 'ym-disable-keys';

function apply (el) {
  if (el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement) {
    el.classList.add(CLASS_NAME);

    return;
  }

  el.querySelectorAll('input, textarea').forEach((field) => {
    field.classList.add(CLASS_NAME);
  });
}

export default {
  inserted: apply,
  componentUpdated: apply,
};
